import { useTranslation } from 'react-i18next';
import { useUnitFormatter } from '@/features/units';
import type { Station } from '../model/types';

/** "Light snow, thunder · 1.2 mm (1 h)", "None", or null when the station does not say. */
export function useWeatherText(s: Station): string | null {
  const { t } = useTranslation('stations');
  const fmt = useUnitFormatter();

  const conditions = (s.weather?.precipitation ?? []).map((p) =>
    t(`precip.intensity.${p.intensity}`, { what: t(`precip.kind.${p.kind}`) }),
  );
  if (s.weather?.thunder) conditions.push(t('precip.thunder'));
  const text = conditions.join(', ');
  const sentence = text && text[0].toUpperCase() + text.slice(1);

  // Non-breaking, so "0.03 in (1 h)" never wraps inside.
  const amount =
    s.precip1h !== null && s.precip1h > 0
      ? t('precip.lastHour', { amount: fmt.precip(s.precip1h) }).replaceAll(' ', '\u00a0')
      : '';
  if (sentence && amount) return `${sentence} · ${amount}`;
  if (sentence) return sentence;
  if (amount) return amount;
  if (s.weather?.complete) return t('precip.none');
  return s.precip1h === 0 ? t('precip.noneLastHour') : null;
}
